import React from 'react';
import { MainPanel } from 'widgets/main';
import { SearchMenu } from 'widgets/search';
import { useChangeStore } from 'features/change-store';
import { useMenuBootstrap } from 'features/menu';
import { RewardsPopup } from 'common/components/RewardsPopup';
import { useAppSelector } from 'app/store/store.hooks';
import { MenuPage } from 'entities/Menu/components/MenuPage';
import { MenuDetailsModal } from 'entities/UI/components/MenuDetailsModal';
import { LastOrderItemModal } from 'entities/UI/components/LastOrderItemModal';
import { StorePickerModal } from 'entities/Store/components/StorePickerModal';
import { ChangeStoreConfirmModal } from 'entities/Store/components/ChangeStoreConfirmModal';

const screenMap = {
  search: SearchMenu,
  menu: MenuPage,
} as const;

const MainPageComponent: React.FC = () => {
  useMenuBootstrap();

  const isSearchMode = useAppSelector((state) => state.search.isEnabledSearch);
  const { handleSelectStore, handleChangeStoreConfirm } = useChangeStore();

  const screenKey: keyof typeof screenMap = isSearchMode ? 'search' : 'menu';
  const Screen = screenMap[screenKey];

  return (
    <>
      <RewardsPopup />
      <MainPanel isSearchMode={isSearchMode} />
      <Screen />

      <MenuDetailsModal />
      <LastOrderItemModal />
      <StorePickerModal onSelect={handleSelectStore} />
      <ChangeStoreConfirmModal onContinue={handleChangeStoreConfirm} />
    </>
  );
};

export const MainPage = MainPageComponent;
